var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinaTvPg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#0F1118",
    opacity: 0.8,
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 29L13.8507 28.9945C12.8159 28.9182 12 28.0544 12 27V20H14V26.999L28 27L32 26.999V16L31.999 12L14 12.001V20H12V12C12 10.9456 12.8159 10.0818 13.8507 10.0055L14 10H32C33.0544 10 33.9182 10.8159 33.9945 11.8507L34 12V27C34 28.0544 33.1841 28.9182 32.1493 28.9945L32 29H14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16H7C6.44772 16 6 16.4477 6 17V25C6 25.5523 6.44772 26 7 26H17C17.5523 26 18 25.5523 18 25V17C18 16.4477 17.5523 16 17 16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2572 21.5919C29.6119 21.2372 29.6119 20.6621 29.2572 20.3074L26.6883 17.7385C26.3336 17.3838 25.7585 17.3838 25.4038 17.7385C25.0491 18.0932 25.0491 18.6683 25.4038 19.023L26.423 20.0423L21.2844 20.0414C20.7828 20.0414 20.3762 20.4481 20.3762 20.9497C20.3762 21.4513 20.7828 21.8579 21.2844 21.8579L26.4217 21.8585L25.4038 22.8764C25.0491 23.2311 25.0491 23.8061 25.4038 24.1608C25.7585 24.5155 26.3336 24.5155 26.6883 24.1608L29.2572 21.5919Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinaTvPg);
export default __webpack_public_path__ + "static/media/WinaTV_PG.0f1e418afe91e3dd55a17757fbed6d8c.svg";
export { ForwardRef as ReactComponent };